module.exports = __webpack_public_path__ + "media/images/application/icons/icon-search-a79e0c7fcf456ec266171d2414721c75.svg";